export class PageVisitedEvent {
  /**
   * Static property for the event type
   * @return {string} The event type identifier
   */
  static get type() {
    return 'pageVisited'
  }

  /**
   * Creates a new PageVisitedEvent
   * @param {Object} params - The event parameters
   * @param {string} [params.pageType] - The type of page being viewed (optional)
   * @param {Object} params.klass - The class information (optional)
   * @param {string} params.klass.id - The ID of the class
   * @param {string} params.klass.name - The name of the class
   */
  constructor({ pageType = null, klass = null }) {
    this.pageType = pageType
    this.klass = klass
  }

  /**
   * Converts the event to a plain object for serialization
   * @return {Object} The event as a plain object
   */
  toObject() {
    return {
      pageType: this.pageType,
      klass: this.klass,
    }
  }
}
